import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.79109 7.67487L4.25659 6.69987V13.9044C4.25653 13.9827 4.27193 14.0602 4.30189 14.1326C4.33186 14.2049 4.37583 14.2706 4.43123 14.326C4.48666 14.3813 4.55243 14.4251 4.62483 14.455C4.69723 14.4848 4.77479 14.5001 4.85309 14.4999H14.4031C14.4815 14.5002 14.5592 14.485 14.6317 14.4553C14.7042 14.4255 14.7701 14.3816 14.8256 14.3263C14.8812 14.271 14.9252 14.2052 14.9552 14.1328C14.9853 14.0604 15.0007 13.9828 15.0006 13.9044V11.2499L9.79109 7.67487Z"
      fill="#185C37"
    />
    <path
      d="M9.79109 1.5H4.85309C4.77479 1.4998 4.69723 1.51507 4.62483 1.54491C4.55243 1.57475 4.48666 1.6186 4.43123 1.67392C4.37583 1.72924 4.33186 1.79496 4.30189 1.8673C4.27193 1.93965 4.25653 2.0172 4.25659 2.0955V4.75L9.79109 8L12.7216 8.975L15.0006 8V4.75L9.79109 1.5Z"
      fill="#21A366"
    />
    <path d="M4.25659 4.75H9.79109V8H4.25659V4.75Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M8.21759 4.10027H4.25659V12.2253H8.21759C8.37543 12.2245 8.52659 12.1615 8.63836 12.0501C8.75009 11.9386 8.81343 11.7876 8.81459 11.6298V4.69577C8.81343 4.53793 8.75009 4.38693 8.63836 4.27547C8.52659 4.164 8.37543 4.10103 8.21759 4.10027Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.89209 4.42513H4.25659V12.5501H7.89209C8.04993 12.5493 8.20109 12.4864 8.31286 12.3749C8.42459 12.2635 8.48792 12.1125 8.48909 11.9546V5.02063C8.48792 4.8628 8.42459 4.7118 8.31286 4.60033C8.20109 4.48887 8.04993 4.4259 7.89209 4.42513Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.89209 4.42513H4.25659V11.9001H7.89209C8.04993 11.8993 8.20109 11.8364 8.31286 11.7249C8.42459 11.6135 8.48792 11.4625 8.48909 11.3046V5.02063C8.48792 4.8628 8.42459 4.7118 8.31286 4.60033C8.20109 4.48887 8.04993 4.4259 7.89209 4.42513Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.56659 4.42513H4.25659V11.9001H7.56659C7.72442 11.8993 7.87559 11.8364 7.98736 11.7249C8.09909 11.6135 8.16242 11.4625 8.16359 11.3046V5.02063C8.16242 4.8628 8.09909 4.7118 7.98736 4.60033C7.87559 4.48887 7.72442 4.4259 7.56659 4.42513Z"
      fill="black"
    />
    <path
      d="M1.597 4.42514H7.566C7.7241 4.425 7.8758 4.48767 7.98777 4.5993C8.0997 4.71097 8.16273 4.86254 8.163 5.02064V10.9796C8.16273 11.1377 8.0997 11.2893 7.98777 11.401C7.8758 11.5126 7.7241 11.5753 7.566 11.5751H1.597C1.51865 11.5754 1.44103 11.5602 1.36857 11.5304C1.29612 11.5006 1.23027 11.4567 1.1748 11.4014C1.11933 11.3461 1.07534 11.2803 1.04534 11.2079C1.01534 11.1356 0.999934 11.058 1 10.9796V5.02064C0.999934 4.9423 1.01534 4.8647 1.04534 4.79234C1.07534 4.71994 1.11933 4.6542 1.1748 4.59887C1.23027 4.54354 1.29612 4.4997 1.36857 4.4699C1.44103 4.44007 1.51865 4.42487 1.597 4.42514Z"
      fill="url(#paint0_linear_6928_2288)"
    />
    <path
      d="M2.85034 9.9368L4.10585 7.9948L2.95584 6.0638H3.87935L4.50685 7.3003C4.56485 7.4173 4.60685 7.5043 4.62585 7.5623H4.63435C4.67535 7.46863 4.71868 7.37763 4.76435 7.2893L5.43535 6.0658H6.28535L5.10585 7.9858L6.31535 9.9383H5.41085L4.68585 8.5828C4.65228 8.52446 4.62368 8.46343 4.60035 8.4003H4.58835C4.56715 8.46183 4.53898 8.5207 4.50435 8.5758L3.75785 9.9368H2.85034Z"
      fill="white"
    />
    <path
      d="M14.4028 1.5H9.79028V4.75H14.9998V2.0955C14.9999 2.01716 14.9845 1.93957 14.9545 1.86719C14.9245 1.79481 14.8805 1.72907 14.825 1.67374C14.7695 1.61841 14.7037 1.57458 14.6312 1.54477C14.5588 1.51495 14.4811 1.49974 14.4028 1.5Z"
      fill="#33C481"
    />
    <path d="M9.79028 8H14.9998V11.25H9.79028V8Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_6928_2288"
        x1="2.247"
        y1="3.95714"
        x2="6.916"
        y2="12.0431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);

export default memo(Icon);
